import Evaporate from 'evaporate'
import random from 'random-gen'
import baseURL from '../../Root/url'
import File from 'orionsoft-parts/lib/components/fields/File'

const config = {
  awsSignatureVersion: '2',
  signerUrl: `${baseURL}/sign_s3`,
  logging: false
}

config.aws_key = 'AKIA6H3TZKEWJI7G7ZM6'
config.bucket = 'tufirma-prod'
//console.log("Usando bucket: " + config.bucket)

const evaporate = new Evaporate(config)

const replaceS3Url = function(name) {
  //console.log("======== awsKey: " + name)
  return `https://s3.amazonaws.com/${config.bucket}/${name}`
}

const uploadFile = function({file, onProgress, onReady, onError}) {

  const id = random.alphaNum(10)
  const name = `${id}_${file.name}`
  console.log("======== file que llega es " + file.type)

  const exppdf = new RegExp('application/pdf');
  const checkfile = exppdf.test(file.type);

  if(navigator.onLine){
  }else{
    setTimeout(()=>{alert('Revisa tu conexión o intenta desde otro dispositivo')},10000);
  }

  evaporate.add({
    name: `static/${name}`,
    file,
    contentType: file.type,
    progress: onProgress,
    error: function(message) {
      console.log(message, 'error uploading file')
      alert('Revisa tu conexión o intenta desde otro dispositivo')
      onError(message)
    },
    complete: function(_xhr, awsKey) {
      console.log('ok01 upload')
      onReady({
        url: replaceS3Url(awsKey),
        meta: {s3Path: '/' + awsKey},
        bool: checkfile,
        nameFile: file.name,
        isPdf: checkfile 
      })
    }
  })
}

const deleteFile = function({file, onReady, onError}) {
  console.log('no delete function')
}

export default {
  type: File,
  upload: uploadFile,
  delete: deleteFile,
}


// WEBPACK FOOTER //
// ./src/App/helpers/fields/fileUpload.js